'use client';

import { usePathname } from 'next/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import CardImage from '@/components/Areas/CardImage';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useLanguage } from '@/app/api/LanguageContext';

const CMS_HOST_URL = process.env.NEXT_PUBLIC_CMS_HOST_URL;

export const SlideArea = (props) => {
    const { dataAreas = [], slideLg, slideMd, slideSm } = props; // Valor por defecto para dataAreas

    const perViewLg = slideLg ?? 3;
    const perViewMd = slideMd ?? 2;
    const perViewSm = slideSm ?? 1;

    const currentPath = usePathname();
    const { locale, changeLocale } = useLanguage();

    return (
        <Swiper
            modules={[Pagination, Navigation, A11y]}
            spaceBetween={32}
            slidesPerView={perViewLg}
            threshold={20}
            navigation
            pagination={{ 
                clickable: true,  
                type: 'fraction'
            }}
            breakpoints={{
                0: {
                    slidesPerView: perViewSm,
                    loop: true,
                },
                768: {
                    slidesPerView: perViewMd,
                    loop: true,
                },
                1024: {
                    slidesPerView: perViewLg,
                    loop: dataAreas.length >= perViewLg * 2, // No hay que hacer la comparación explícita con true
                },
            }}
        >
            {dataAreas.map((area, index) => {
                const {
                    id,
                    attributes: {
                        featured_image: {
                            data: {
                                attributes: { url: urlImg } = {},
                            } = {},
                        } = {},
                        url,
                        epigraph,
                        title,
                        custom_title,
                        short_description,
                        button_title,
                        button_class,
                        button_url,
                    },
                } = area;

                /*const areaUrl = currentPath.includes('areas/') 
                    ? `/${locale}${url.replace('areas/', '')}` 
                    : `/${locale}/areas/${url}`;

                    console.log(url);*/

                const areaUrl = `/${locale}/areas/${url}`;

                // Ahora puedes usar `areaUrl` en el botón
                return (
                    <SwiperSlide key={`${id}-${index}`}>
                        <CardImage
                            img={CMS_HOST_URL + urlImg}
                            epigraph={epigraph}
                            title={custom_title ?? title}
                            excerpt={short_description}
                            buttonProps={{
                                label: locale === 'es' ? 'Conocer más' : 'Learn more',
                                customClass: button_class,
                                url: areaUrl,
                            }}
                        />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};
